export default __webpack_public_path__ + "static/slider-418ce4786ebb79492c85559370cd7e5a.png";